import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { cloneDeep } from 'lodash'

import { Get, Put, Post } from 'utils/axios-token'
import { Get as GetTemplate } from 'utils/axios-template'
import { GetWithNonce } from 'utils/axios-nonce'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import { GERMANY_STATES, COUNTRY_LANGUAGES } from './assets'
import Lang from 'Lang/General'

const HOC = WrappedComponent => {
  class WithHOC extends Component {
    state = {
      onLoadPortalMatchmakingHoc: false,
      portalUserMatchmakings: [],
      currentMatchmakings: {},
      countries: [],
      states: [],
      portalUserBrands: [],
      isPortalUserMatchmakingsLoaded: false,
      isCountriesLoaded: false,
      isStatesLoaded: false,
      isPortalUserBrandsLoaded: false,
      portalUserMatchmakingErrors: [{}],
      selectedMatchmakingIndex: 0,
      fairCountries: [],
      selectedMatchmakingCountry: ''
    }

    load = param => this.setState({ onLoadPortalMatchmakingHoc: param })
    requestSuccess = success => {
      toast.success(success)
      let tmpErrors = cloneDeep( this.state.portalUserMatchmakingErrors )
      tmpErrors[ this.state.selectedMatchmakingCountry ][ this.state.selectedMatchmakingIndex ] = {}
      this.setState({ portalUserMatchmakingErrors: tmpErrors })
    }
    requestError = error => {
      if (typeof error === 'string') {
        toast.error(error)
      } else {
        let tmpErrors = cloneDeep(this.state.portalUserMatchmakingErrors)
        tmpErrors[ this.state.selectedMatchmakingCountry ][ this.state.selectedMatchmakingIndex ] = error
        this.setState({ portalUserMatchmakingErrors: tmpErrors })
      }
    }

    onChangePortalMatchmakingHOC = (key, value) => this.setState({ [key]: value })

    createPortalUserMatchmaking = data => Post(
      '/api/v1/fex/matchmakings',
      data,
      this.createPortalUserMatchmakingSuccess,
      this.createPortalUserMatchmakingError,
      this.load
    )
    createPortalUserMatchmakingSuccess = payload => {
      let tmpMatchmakings = cloneDeep(this.state.currentMatchmakings)
      tmpMatchmakings[ this.state.selectedMatchmakingCountry ][ this.state.selectedMatchmakingIndex ].id = payload.id
      this.setState({ currentMatchmakings: tmpMatchmakings })
      this.requestSuccess(Lang['MATCHMAKING_CRITERIA_ARE_UPDATED_SUCCESSFULLY'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }
    createPortalUserMatchmakingError = error => {
      this.requestError(error)
      this.requestError(Lang['FAILED_TO_UPDATE_MATCHMAKING_CRITERIA'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }

    getPortalUserMatchmakings = id => Get(
      `/api/v1/fex/matchmakings/${id}`,
      this.getPortalUserMatchmakingsSuccess,
      this.getPortalUserMatchmakingsError,
      this.load
    )
    getPortalUserMatchmakingsSuccess = payload => {
      this.setState({
        portalUserMatchmakings: payload,
        isPortalUserMatchmakingsLoaded: true
      })
    }
    getPortalUserMatchmakingsError = () => { }

    updatePortalUserMatchmaking = data => Put(
      `/api/v1/fex/matchmakings/${data.id}`,
      data,
      this.updatePortalUserMatchmakingSuccess,
      this.updatePortalUserMatchmakingError,
      this.load
    )
    updatePortalUserMatchmakingSuccess = () => this.requestSuccess(Lang['MATCHMAKING_CRITERIA_ARE_UPDATED_SUCCESSFULLY'][this.props.data.languageReducer.userSettings.admin_panel_language])
    updatePortalUserMatchmakingError = error => {
      this.requestError(error)
      this.requestError(Lang['FAILED_TO_UPDATE_MATCHMAKING_CRITERIA'][this.props.data.languageReducer.userSettings.admin_panel_language])
    }

    getBrandsListing = portalUserID => Get(
      `/api/v1/fex/brands?query=${convertSearchObjectToBase64({ "is_paginated": false, "filter": { "user_id": portalUserID } })}`,
      payload => this.setState({
        portalUserBrands: payload.data,
        isPortalUserBrandsLoaded: true
      }),
      error => this.requestError(error),
      this.load
    )

    getCountries = () => GetWithNonce(
      `/api/v1/countries?language=${ COUNTRY_LANGUAGES[ this.props.data.languageReducer.userSettings.admin_panel_language ] }`,
      this.getCountriesSuccess,
      this.getCountriesError,
      this.load
    )
    getCountriesSuccess = payload => {
      let tmpIndex = payload.findIndex(country => country.alpha3 === 'DEU')
      if (tmpIndex > -1) {
        this.getStates(payload[tmpIndex].id)
      }
      this.setState({
        isCountriesLoaded: true,
        countries: payload.map(country => ({
          id: country.alpha3,
          label: country.name,
          value: country.alpha3
        }))
      })
    }
    getCountriesError = () => { }

    getStates = country_id => GetTemplate(
      `/api/v1/countries/${country_id}/states`,
      this.getStatesSuccess,
      this.getStatesError,
      this.load
    )
    getStatesSuccess = () => this.setState({
      isStatesLoaded: true,
      states: GERMANY_STATES.map(state => ({
        id: state.code,
        label: state.name,
        value: state.code
      }))
    })
    getStatesError = () => { }

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onChangePortalMatchmakingHOC={this.onChangePortalMatchmakingHOC}
          createPortalUserMatchmaking={this.createPortalUserMatchmaking}
          getPortalUserMatchmakings={this.getPortalUserMatchmakings}
          updatePortalUserMatchmaking={this.updatePortalUserMatchmaking}
          getBrandsListing={this.getBrandsListing}
          getCountries={this.getCountries}
        />
      )
    }
  }
  const mapStateToProps = props => ({ data: props })
  return connect(mapStateToProps)(WithHOC)
}
export default HOC